<template>
    <div>
        <div
                class="form-group mt-2"
                v-for="signer in items.iten.signers"
                v-bind:key="signer.id">
            <div class="row gutters">
                <div class="list-primary hide-text col-8"
                     style="display: inline-block">
                    <div :data-tooltip=stats(signer.status_of_signature) data-flow="bottom">
                        <div
                                id="statusSigner"
                                :class="selectClass(signer.status_of_signature)"></div>
                    </div>
                    <div
                            class="name-signer">{{ signer.name }}
                    </div>
                    <div
                            v-if="signer?.email"
                            class="font-weight-bold"
                            style="font-size: smaller; color: grey;margin-left: 23px;"
                            id="sing_mail"> {{ signer.email }}
                    </div>
                    <div
                            v-if="signer?.documentation"
                            class="font-weight-bold"
                            style="font-size: smaller; color: grey;margin-left: 23px;"
                            id="sing_documentation"> {{ signer.documentation }}
                    </div>
                    <div
                            class="font-weight-bold"
                            style="font-size: smaller; color: grey;margin-left: 23px;"
                            id="sing_as"> {{ stats(signer.sign_as) }}
                    </div>
                    <div
                            v-if="isPresentialV3Signer(signer)"
                            style="margin-left: 23px;"
                            class="mt-1">
                        <span class="badge badge-info" title="O token de assinatura é enviado por e-mail ao anfitrião">
                            Assinatura presencial
                        </span>
                        <span
                                v-if="signer.signature_host?.name || signer.signature_host?.email"
                                class="font-weight-bold ml-1"
                                style="font-size: smaller; color: grey;">
                            Anfitrião: {{ signer.signature_host?.name }}<template v-if="signer.signature_host?.email"> ({{ signer.signature_host.email }})</template>
                        </span>
                        <div v-if="signer.presential_session_sent_at && signer.signed_at === null"
                             class="text-success font-weight-bold mt-1"
                             style="font-size: smaller;">
                            <i class="icon-check"></i> Link e token de assinatura enviados ao anfitrião em {{ formatDate(signer.presential_session_sent_at) }}
                        </div>
                    </div>
                </div>
                <div v-if="signer.signed_at === null && items?.iten?.status === 'running'"
                     class="mt-3 d-flex flex-row justify-content-end col-4">
                    <div v-if="signer.signed_at === null"
                         class="pointer mr-2 align-self-center">
                        <a title="Editar Configuração do Signatário"
                           data-toggle="modal" data-target="#customModalTwo"
                           @click="$emit('setModalEditSign',signer)">
                            <i class="icon-pencil doc-action-icon"></i>
                        </a>
                    </div>
                    <div v-if="signer.signed_at === null"
                         class="pointer mr-2 align-self-center">
                        <a :title="isPresentialV3Signer(signer) ? 'Preparar Sessão Presencial do Anfitrião' : 'Copiar Link de Solicitação de Assinatura'"
                           @click="copySignerAccess(signer)">
                            <i class="icon-copy doc-action-icon"></i>
                        </a>
                    </div>
                    <div v-if="!isPresentialV3Signer(signer)" class="pointer align-self-center">
                        <a title="Solicitação de assinatura via whatsapp"
                           @click="sendWhatsapp(signer)">
                            <img src="/img/whatsapp.png">
                        </a>
                    </div>
                </div>
                <div v-if="signer.signed_at !== null" class="col-4 d-flex flex-row justify-content-end">
                    <div>
                        <label>{{ t("DOCUMENTS.DATE_OF_ASSYGN") }}:</label>
                        <div>{{ formatDate(signer.signed_at) }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {useI18n} from 'vue-i18n';
import {useToast} from 'vue-toastification';
import {mapActions} from 'vuex';
import documentMixin from '../../../mixins/documentMixin';
import {isV3Signer} from '../../../services/clicksignVersion';

export default {
    name: "detailsItensComponent",
    props: ['items'],
    setup() {
        const {t} = useI18n();
        const toast = useToast();
        return {t, toast}
    },
    mixins: [documentMixin],
    methods: {
        ...mapActions({
            preparePresentialSession: 'preparePresentialSession'
        }),
        isPresentialV3Signer(signer) {
            return isV3Signer(signer) && (signer.is_presential || signer.signature_mode === 'presential');
        },
        copySignerAccess(signer) {
            if (this.isPresentialV3Signer(signer)) {
                this.preparePresentialSession({signer}).then((data) => {
                    if (data?.session?.sent_at) {
                        signer.presential_session_sent_at = data.session.sent_at;
                    }
                }).catch(() => {});
                return;
            }

            this.copyToClipboard(signer.url_signature);
        }
    }
}
</script>

<style scoped>

</style>
